import styled from 'styled-components';

const Wrapper = styled.div<{ $note?: boolean; }>`
  position: relative;

  .alert-total {
    display: flex;
    align-items: center;
    padding: 0 0 8px 15px;

    h2 {
      flex: 0 1 auto;
    }
  }

  .report-button {
    position: absolute;
    right: 0;
    top: ${(props) => (props.$note ? '-231px' : '-65px')};
  }

  &:has(.row) {
    min-width: 0;
  }

  .entities-list {
    height: 430px;
    overflow-y: auto;

    &.with-alert-total {
      height: calc(430px - 40px);
    }
    /* scroll-behavior: smooth; */
    &.note {
      height: calc(430px - 166px);
    }
    /* padding: 16px; */

    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      /* width: 12px; */
      display: none;
    }

    .no-data {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 18px;
      color: ${(props) => props.theme.colors.text};
      opacity: 0.35;
    }

    .list-loading {
      height: 20px;
      margin-left: 15px;
      overflow-anchor: none;
    }

    .list-container {
      display: flex;
      flex-direction: column;

      &.row {
        flex-direction: row;
        flex-wrap: wrap;
        column-gap: 16px;
        row-gap: 16px;
      }
    }
  }
`;

export default { Wrapper };
